import { CoreSlider } from "@boi/components-core";
import { SliderBaseProps } from "..";

type Params = Pick<SliderBaseProps, "value" | "minValue" | "maxValue">;

export const useSliderValueAsPercent = ({
  value,
  minValue = CoreSlider.DEFAULT_MIN_VALUE,
  maxValue = CoreSlider.DEFAULT_MAX_VALUE,
}: Params): number => {
  const baselinedValue = value - minValue;
  const baselinedMaxValue = maxValue - minValue;
  const percent = (baselinedValue / baselinedMaxValue) * 100;
  return percent;
};
